const SET_MESSAGES = 'SET_MESSAGES';
const SET_PARTICIPANT = 'SET_PARTICIPANT';
const SET_EVENT_SLUG = 'SET_EVENT_SLUG';
const RESET_STATES = 'RESET_STATES';

const state = {
	messages: [],
	participant: [],
	eventSlug: null,
};

const getters = {
	messages: state => state.messages,
	participant: state => state.participant,
	eventSlug: state => state.eventSlug,
};

const mutations = {
	[RESET_STATES](state) {
		state.messages = [];
		state.participant = [];
		state.eventSlug = null;
	},
	[SET_MESSAGES](state, messages) {
		state.messages = messages;
	},
	[SET_PARTICIPANT](state, participant) {
		state.participant = participant;
	},
	[SET_EVENT_SLUG](state, eventSlug) {
		state.eventSlug = eventSlug;
	},
	SOCKET_MESSAGES_ADD(state, message) {
		if (state.participant) {
			const isRecipient = parseInt(message.recipient_id) === parseInt(state.participant.id);
			if (isRecipient) {
				state.messages.unshift(message);
			}
		}
	},
	SOCKET_MESSAGES_UPDATE(state, message) {
		if (state.messages && state.messages.length > 0) {
			state.messages = state.messages.map((current) => {
				if (parseInt(current.id) === parseInt(message.id)) {
					return Object.assign({}, current, message);
				}
				return current;
			});
		}
	},
	SOCKET_MESSAGES_DELETE(state, messageId) {
		if (state.messages && state.messages.length > 0) {
			for (let j = 0; j < state.messages.length; j++) {
				const current = state.messages[j];
				if (current.id === messageId) {
					state.messages.splice(j, 1);
					break;
				}
			}
		}
	},
	SOCKET_MESSAGES_BULKDELETE(state, messageIds) {
		if (state.messages && state.messages.length > 0) {
			for (let i = 0; i < messageIds.length; i++) {
				const messageId = messageIds[i];
				for (let j = 0; j < state.messages.length; j++) {
					const current = state.messages[j];
					if (current.id === messageId) {
						state.messages.splice(j, 1);
						break;
					}
				}
			}
		}
	},
	SOCKET_MESSAGES_MARK_AS_READ(state, messages) {
		if (state.messages && state.messages.length > 0) {
			for (let i = 0; i < messages.length; i++) {
				const message = messages[i];
				state.messages = state.messages.map((current) => {
					if (parseInt(current.id) === parseInt(message.id)) {
						return Object.assign({}, current, message);
					}
					return current;
				});
			}
		}
	},
};

const actions = {
	setMessages({ commit }, messages) {
		commit(SET_MESSAGES, messages);
	},
	setParticipant({ commit }, participant) {
		commit(SET_PARTICIPANT, participant);
	},
	setEventSlug({ commit }, eventSlug) {
		commit(SET_EVENT_SLUG, eventSlug);
	},
	resetStates({ commit }) {
		commit(RESET_STATES);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
